/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPmiReferenceGeometry = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 17.178V7h3.682c1.195 0 2.105.266 2.73.798s.938 1.302.938 2.31c0 .747-.196 1.367-.588 1.862-.383.495-.938.84-1.666 1.036l2.688 4.172H9.838l-2.38-3.836-1.722-.35v4.186H4zm1.736-5.334h1.302c.644 0 1.153-.056 1.526-.168.373-.112.64-.29.798-.532.159-.252.238-.588.238-1.008 0-.43-.08-.77-.238-1.022-.159-.252-.425-.43-.798-.532-.373-.112-.882-.168-1.526-.168H5.736v3.43zm7.064 4.522-.252-.854 1.162-1.708c-.457-.43-.686-.985-.686-1.666 0-.775.27-1.381.812-1.82.55-.439 1.316-.658 2.296-.658.495 0 .952.07 1.372.21l2.464-.014v.854l-.868.308c.299.327.448.742.448 1.246 0 .737-.29 1.316-.868 1.736-.579.42-1.377.63-2.394.63-.56 0-1.06-.07-1.498-.21l-.574.854 3.444.448c.793.093 1.377.313 1.75.658.383.336.574.807.574 1.414 0 .728-.331 1.302-.994 1.722-.663.43-1.563.644-2.702.644-1.167 0-2.063-.182-2.688-.546-.616-.355-.924-.868-.924-1.54 0-.607.28-1.139.84-1.596l-.714-.112zm1.806-4.228c0 .859.56 1.288 1.68 1.288 1.12 0 1.68-.43 1.68-1.288 0-.85-.56-1.274-1.68-1.274-1.12 0-1.68.425-1.68 1.274zm-.308 5.6c0 .756.663 1.134 1.988 1.134.644 0 1.143-.089 1.498-.266.364-.177.546-.425.546-.742 0-.243-.075-.425-.224-.546-.14-.112-.397-.196-.77-.252l-2.562-.392c-.317.308-.476.663-.476 1.064z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPmiReferenceGeometry as PmiReferenceGeometry };
